<template>
    <div>
        <v-container fluid class="px-0 search-doctor-banner pb-0 d-flex justify-center align-center" :style="$vuetify.breakpoint.mdAndUp ? 'min-height: 230px' : 'min-height: 175px'">
            <v-container fluid class="pb-0" :class="{'pl-12': $vuetify.breakpoint.mdAndUp}">
                <v-row>
                    <v-col cols="12">
                        <div class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                            Search Questions And Answers
                        </div>
                        <div class="darkergray--text playfair-display mb-2 weight-semibold text-center" :class="$vuetify.breakpoint.mdAndUp ? 'font-32' : 'font-16'">
                            Get on-demand consultations as and when you need them.
                        </div>
                    </v-col>
                                       
                </v-row>
            </v-container>
        </v-container>
        <v-container style="margin-top:-50px;">
            
            <v-row class="">
                <v-col cols="12" sm="12" md="6" offset-md="3">
                    
                    <v-card class="" elevation="1">
                        <v-card-text class="pb-1">
                            <v-row no-gutters>
                                <v-col cols="9" sm="9" md="9" lg="10">
                                    <v-text-field
                                        prepend-inner-icon="mdi-help-circle-outline"
                                        dense
                                        color="#9b9b9b"
                                        class="custom-textfield"
                                        v-model="searchedQuery"                                        
                                        placeholder="Search Question or Answer"
                                        outlined
                                    ></v-text-field>      
                                </v-col>
                                <v-col cols="3" sm="3" md="3" lg="2" class="pl-2">
                                    <v-btn outlined class="searchbtn weight-semibold" 
                                            @click="search()">Search
                                    </v-btn>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>
                    </v-card>
                </v-col>
                                
            </v-row>
        </v-container>
        <v-container>
            <!--            Question List-->
            
            <v-row>
            
                <v-col cols="12" id="raq">
                    <h1 class="text-center playfair-display" >Recently Asked Questions</h1>                    
                </v-col>
                <v-col cols="12" sm="12" md="12">                    
                    <v-row v-if="questionsList.length && !questionsListLoader">
                        <v-col cols="12">
                            <h5 class="text-center playfair-display">{{ totalQuestions }} Result(s)</h5>
                        </v-col>
                        <v-col cols="12" sm="12" md="4" v-for="question in questionsList" :key="question.id"
                               class="d-flex" style="flex-direction:column">
                            <v-card class="lightgray"
                                    hover
                                    @click="goToDetails(question)"
                                    style="height: 100%; border-top: 10px solid #e7f5e7 !important">
                                <v-card-text>
                                    <v-row>
                                        <v-col>
                                            <v-chip label class="light-blue lighten-5 secondaryVariant--text weight-bold font-15">
                                                {{ pluralize(question.total_answers,"Answer") }}
                                            </v-chip>
                                        </v-col>
                                        <v-col class="d-flex justify-end">
                                            {{ dateutils.utcToLocal(question.created_at).format('M MMM \'YY, hh:mm A') }}
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <h2 class="black--text font-weight-bold qna-section">
                                                <div v-html="highlight(question.title)">
                                                </div>                                                                        
                                            </h2>
                                            <br>
                                            <h4 class="font-weight-regular qna-section">
                                                <div v-html="highlight(question.description)">
                                                </div>
                                            </h4>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12">
                                            <v-divider></v-divider>
                                            <v-list-item v-if="question.patient" class="ma-0 pa-0">
                                                
                                                <v-icon class="secondaryVariant--text font-30 ">
                                                    mdi-account-circle
                                                </v-icon>
                                                
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        class="ml-1"
                                                        v-html="question.patient.gender" 
                                                        style="text-transform: capitalize;"
                                                    >
                                                    </v-list-item-title>                                                 
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" >
                            <div class="text-center">
                                <v-pagination
                                v-model="current_page"
                                :length="totalPages"
                                :total-visible="7"
                                ></v-pagination>
                            </div>
                        </v-col>    
                         
                    </v-row>
                    <v-row v-if="!questionsListLoader && !questionsList.length" class="text-center mt-4 mb-4">
                        <v-col cols="12" sm="12" md="12" >
                            <h3 class="text-center playfair-display">No Questions Found</h3>
                        </v-col>    
                    </v-row>
                    <v-row v-if="questionsListLoader" class="text-center">
                        <v-col cols="12">
                            <br><br><br>
                            <v-progress-circular
                                    size="50"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="px-0 pb-0 lightBackground" style="min-height: 150px" id="ask">
            <v-container fluid class="pb-0">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <h1 class="playfair-display mb-2 font-weight-bold text-center" id="question_title">
                                Ask Your Question
                            </h1>
                            <h4 class="opacity-8 font-weight-regular text-center">
                                HeatlhyAlways provides you with an easy way to ask your queries to Healthcare Professionals anytime.
                            </h4>
                        </v-col>
                       <v-col cols="12" class="ask-question-banner my-3">
                           <v-card class="transparent" flat>
                               <v-card-text>
                                   <v-col cols="12" sm="12" md="6">
                                       <v-card style="position: relative">
                                           <div style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: white; z-index: 1; text-align: center"
                                                v-if="submitSuccess">
                                               <v-icon color="grey darken-2" style="font-size: 150px" class="mt-12">
                                                   mdi-checkbox-marked-circle-outline
                                               </v-icon>
                                               <br>
                                               <h2 class="font-weight-regular mb-5">
                                                   Your Question has been submitted.
                                               </h2>
                                               <h4 class="grey--text text--lighten-1 font-weight-regular">
                                                   Complete your profile and keep track of all your questions, book appointments &
                                                   save medical records.
                                               </h4>
                                               <br>
                                               <v-btn text class="accent white--text mr-4" @click="goToPatientPortalMain('')">
                                                   Explore Dashboard
                                               </v-btn>
                                           </div>
                                           <v-card-text>
                                               <v-form >
                                                   <v-row no-gutters>
                                                       <v-col cols="12" sm="12">
                                                           <v-text-field solo flat background-color="grey lighten-3"
                                                           hide-details="auto"
                                                                         placeholder="Enter Title"
                                                                         v-model="submitQuestionRequest.title"></v-text-field>
                                                       </v-col>
                                                       <v-col cols="12" sm="12" v-if="submitQuestionRequest.title">
                                                           <div class="mt-1">
                                                               <a class="font-12 weight-semibold" href="#" @click="searchMathchingQuestions">{{ submitQuestionRequest.matchingResults }} matching result(s) found with answers. Click here to view them.</a>                                                               
                                                           </div>
                                                       </v-col>
                                                       <v-col cols="12" sm="12" class="mt-8">
                                                           <v-textarea placeholder="Description" solo flat
                                                                       background-color="grey lighten-3"
                                                                       v-model="submitQuestionRequest.description"></v-textarea>
                                                       </v-col>
                                                       <v-col cols="12" sm="12">
                                                           <v-autocomplete
                                                                   :items="specializationList"
                                                                   v-model="submitQuestionRequest.specialization_ids"
                                                                   solo flat
                                                                   background-color="grey lighten-3"
                                                                   item-text="name"
                                                                   item-value="id"
                                                                   :allow-overflow="false"
                                                                   clearable
                                                                   placeholder="Select Health Concern"
                                                           ></v-autocomplete>
                                                       </v-col>
                                                       <!--                                            <v-col cols="12" sm="12">-->
                                                       <!--                                                <v-autocomplete-->
                                                       <!--                                                        :items="symptomsList"-->
                                                       <!--                                                        v-model="submitQuestionRequest.symptom_ids"-->
                                                       <!--                                                        solo flat-->
                                                       <!--                                                        background-color="grey lighten-3"-->
                                                       <!--                                                        item-text="name"-->
                                                       <!--                                                        item-value="id"-->
                                                       <!--                                                        :allow-overflow="false"-->
                                                       <!--                                                        clearable-->
                                                       <!--                                                        multiple-->
                                                       <!--                                                        placeholder="Select Symptoms..."-->
                                                       <!--                                                >-->
                                                       <!--                                                </v-autocomplete>-->
                                                       <!--                                            </v-col>-->
                                                       <v-col cols="12" sm="12" class="text-center">
                                                           <v-btn @click.prevent="submitQuestion" class="accent white--text"
                                                                  :loading="submitLoader"
                                                                  :disabled="submitLoader"
                                                                  rounded>
                                                               Submit Question
                                                               <v-icon right>mdi-arrow-right</v-icon>
                                                           </v-btn>
                                                       </v-col>
                                                   </v-row>
                                               </v-form>
                                           </v-card-text>
                                       </v-card>
                                   </v-col>
                               </v-card-text>
                           </v-card>
                       </v-col>
                    </v-row>
                </v-container>
            </v-container>
        </v-container>


        <!--        Login Modal-->
        <v-dialog v-model="loginDialog" max-width="900" persistent>
            <v-card>
                <patient-login @loginResult="submitQuestion"></patient-login>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="loginDialog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import PatientLogin from "../components/Login/PatientLogin";

    export default {
        name: "QnA",
        components: {
            PatientLogin
        },
        computed: {
            ...mapGetters([
                'accessToken',
                'userInfo'
            ]),
        },
        mounted() {
            window.screenTop = 0
            console.log("MOUNTED")
            
            if(this.$route.query.page){
                this.totalPages = this.$route.query.page
                console.log(this.$route.query.page)
                this.current_page = parseInt(this.$route.query.page)
            }
                
            if(this.$route.query.query){
                this.searchedQuery = this.$route.query.query                
            }
                

            this.getQuestionList();
            this.getSymptomsList();
            this.getSpecializationList();
            document.getElementById('raq').scrollIntoView();
        },
        data() {
            return {
                submitLoader: false,
                loginDialog: false,
                questionsListLoader: false,
                searchQuestionRequest: {
                    title: '',
                    page:1,
                    format_type:'paginate',
                    limit:15
                },
                submitQuestionRequest: {
                    title: '',
                    description: '',
                    specialization_ids: [],
                    symptom_ids: [],
                    findQuestionLoading:false,
                    matchingResults:0
                },
                questionsList: [],
                current_page: 1,
                totalPages:0,
                symptomsList: [],
                totalQuestions:0,
                specializationList: [],
                endMessage: '',
                submitSuccess: false,                                
                searchedQuery:''
            }
        },
        methods: {
            goToDetails(question){
                document.getElementById('raq').scrollIntoView();       
                this.$router.push({name: 'askAQuestionDetail', params: {
                            id: question.id,
                            slug: this.getSlugFromString(question.title)
                        },
                        query:{
                            query:this.searchQuestionRequest.title
                        }
                        })
            },
            highlight(text) {                
                if(!this.searchQuestionRequest.title) {
                    return text;
                }
                return text.replace(new RegExp(this.searchQuestionRequest.title, "gi"), match => {
                    
                    return '<span class="highlightText">' + match + '</span>';
                });
            },
            searchMathchingQuestions(){                
                this.searchedQuery = this.submitQuestionRequest.title
                this.updateRouterParams()
                //this.search()
            },
            showDoctorProfile(doctor) {
              let routeData = this.$router.resolve({name: 'DoctorDetails', params: {id: doctor.unique_no, slug: this.getSlugFromString(doctor.name)}});
              window.open(routeData.href, '_blank');
            },
            getQuestionList() {
                
                this.searchQuestionRequest.title = this.searchedQuery
                this.searchQuestionRequest.page = this.current_page
                this.questionsListLoader = true;
                this.endMessage = '';
                this.questionsList = [];
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/questions`,{
                        params:this.searchQuestionRequest
                    })
                    .then((response) => {
                        this.totalPages = response.data.data.last_page
                        this.questionsList = response.data.data.data;                        
                        this.questionsListLoader = false;
                        this.totalQuestions = response.data.data.total;
                    }).catch((error) => {
                    console.log(error);
                });
            },
            getSymptomsList() {
                // this.axios
                //     .get(`${process.env.VUE_APP_API_URL}/api/symptoms/search`)
                //     .then((response) => {
                //         this.symptomsList = response.data.data;
                //     }).catch((error) => {
                //     console.log(error);
                // });
            },
            getSpecializationList() {
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/specializations`)
                    .then((response) => {
                        this.specializationList = response.data.data;
                    }).catch((error) => {
                    console.log(error);
                });
            },
            submitQuestion() {
                if (!this.userInfo) {
                    this.loginDialog = true;
                    return;
                }
                this.loginDialog = false;
                this.submitLoader = true;
                this.submitQuestionRequest.patient_id = this.userInfo.id;
                this.axios
                    .post(`${process.env.VUE_APP_API_URL}/api/questions`, this.submitQuestionRequest)
                    // eslint-disable-next-line no-unused-vars
                    .then((response) => {
                        if(response.data.status == 1){
                            this.submitQuestionRequest = {
                                title: '',
                                description: '',
                                specialization_ids: [],
                                symptom_ids: [],

                            };
                            this.submitSuccess = true;
                            this.submitLoader = false;
                        }
                        else{
                            this.submitLoader = false;
                        }
                        
                    }).catch((error) => {
                    this.submitLoader = false;
                    console.log(error);
                });
            },
            findMatchingQuestions() {                                
                
                this.submitQuestionRequest.findQuestionLoading = true;
                this.axios
                    .get(`${process.env.VUE_APP_API_URL}/api/questions/findMatchingResults`,{
                        params:{
                            title:this.submitQuestionRequest.title
                        }
                    })
                    .then((response) => {                        
                        this.submitQuestionRequest.matchingResults = response.data.data                        
                    }).catch((error) => {
                        console.log(error);
                    }).finally(() => {
                        this.submitQuestionRequest.findQuestionLoading = false;
                    })
            },
            search(){
                console.log("AQSEWSDA")
                this.current_page = 1
                this.updateRouterParams()
                //this.getQuestionList()
            },
            updateRouterParams(){
                document.getElementById('raq').scrollIntoView();       
                this.$router.push({name: 'askAQuestion', query: {page: this.current_page, query:this.searchedQuery}})
            }
        },
        watch:{
            current_page () {                         
                // this.updateRouterParams();                
                this.updateRouterParams();
                //this.getQuestionList()                
            },
            'submitQuestionRequest.title':function(){
                document.getElementById('question_title').scrollIntoView();       
                this.findMatchingQuestions()
            }
        }
    }
</script>

<style>
    .city-select .v-input__control .v-input__slot {
        border-left: 1px solid #4e738a !important;
    }
</style>